import { FirebaseError } from 'firebase/app';

/*
 * 画面に表示するエラーの詳細を取り出す
 * Firebaseのエラーであればエラーコード（permission-deniedなど）を返す
 */
export const getErrorDetail = (error: Error): string | null => {
  const { cause } = error;

  if (cause instanceof FirebaseError) {
    return cause.code;
  }

  if (cause instanceof Error) {
    return cause.message;
  }

  return null;
};
